import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: require('./locales/en/translation.json'),
    },
    fr: {
      translation: require('./locales/fr/translation.json'),
    },
    it: {
      translation: require('./locales/it/translation.json'),
    },
    es: {
      translation: require('./locales/es/translation.json'),
    },
    br: {
      translation: require('./locales/br/translation.json'),
    },
    zu: {
      translation: require('./locales/zu/translation.json'),
    },
    de: {
      translation: require('./locales/de/translation.json'),
    },
    zh: {
      translation: require('./locales/zh/translation.json'),
    },
  },
})

export default i18n
